import type { IconProps } from './types'

export const FlagFrIcon = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 64 48"
      className={className}
      aria-hidden="true"
    >
      <rect width="64" height="48" rx="8" fill="#fff" />
      <path d="M0 0H21.33V48H0Z" fill="#0055A4" />
      <path d="M42.67 0H64V48H42.67Z" fill="#EF4135" />
    </svg>
  )
}
